import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '/@/modules/core/app/helpers/store';
import { Estate } from '@/modules/estate/models/Estate';

export class ClearVaultFinalReportExportService extends ExportTypeBaseService {
  estate?: Estate;

  getFilename(): string {
    this.estate = getters.export.getData().estate;
    return `${this.estate?.contact.fullName.replaceAll(' ', '-')}-final-report.pdf`;
  }

  getSnackBarTitle(): string {
    this.estate = getters.export.getData().estate;
    return Lang.t('estate.final-report-exporting', {
      name: this.estate?.contact.fullName
    });
  }
}

export default new ClearVaultFinalReportExportService();
